import { ProblemDefinition } from './types';

const schemaDDL = `
CREATE TABLE departments (id INTEGER PRIMARY KEY, name TEXT NOT NULL, budget REAL);
CREATE TABLE employees (id INTEGER PRIMARY KEY, first_name TEXT NOT NULL, last_name TEXT NOT NULL, dept_id INTEGER, salary REAL, hire_date TEXT, manager_id INTEGER, FOREIGN KEY(dept_id) REFERENCES departments(id), FOREIGN KEY(manager_id) REFERENCES employees(id));
`;

const seedDML = `
INSERT INTO departments (id, name, budget) VALUES
  (1, 'Engineering', 500000),
  (2, 'Sales', 300000),
  (3, 'Marketing', 200000),
  (4, 'HR', 150000);

INSERT INTO employees (id, first_name, last_name, dept_id, salary, hire_date, manager_id) VALUES
  (1, 'Alice', 'Johnson', 1, 95000, '2020-03-15', NULL),
  (2, 'Bob', 'Smith', 1, 88000, '2021-06-01', 1),
  (3, 'Carol', 'Williams', 2, 72000, '2019-11-20', NULL),
  (4, 'David', 'Brown', 2, 65000, '2022-01-10', 3),
  (5, 'Eva', 'Davis', 3, 78000, '2020-07-22', NULL),
  (6, 'Frank', 'Miller', 1, 92000, '2018-09-05', 1),
  (7, 'Grace', 'Wilson', NULL, 60000, '2023-02-14', NULL),
  (8, 'Henry', 'Taylor', 3, 70000, '2021-04-30', 5),
  (9, 'Ivy', 'Anderson', 4, 67000, '2022-08-18', NULL),
  (10, 'Jack', 'Thomas', NULL, 55000, '2023-05-01', NULL);
`;

export const dmlProblems: ProblemDefinition[] = [
 {
  id: 'dml-easy-1',
  title: 'Insert a New Employee',
  statement: `Insert a new employee with the following data:\n\n- **id:** 11\n- **first_name:** 'Kevin'\n- **last_name:** 'Lee'\n- **dept_id:** 2\n- **salary:** 71000\n- **hire_date:** '2024-01-15'\n- **manager_id:** 3\n\nAfter your INSERT, verify with:\n\`\`\`sql\nSELECT * FROM employees WHERE id = 11;\n\`\`\``,
  schemaDDL,
  seedDML,
  expectedOutput: {
   columns: ['id', 'first_name', 'last_name', 'dept_id', 'salary', 'hire_date', 'manager_id'],
   values: [
    [11, 'Kevin', 'Lee', 2, 71000, '2024-01-15', 3],
   ],
  },
  comparisonMode: 'order-sensitive',
  difficulty: 'easy',
  topicTags: ['dml'],
  hints: [
   'Use INSERT INTO employees (columns...) VALUES (values...);',
   'Follow the INSERT with a SELECT to verify: SELECT * FROM employees WHERE id = 11;',
   'The last SELECT result is what gets compared to the expected output.',
  ],
 },
 {
  id: 'dml-easy-2',
  title: 'Give Engineering a Raise',
  statement: `Give all employees in the **Engineering** department (dept_id = 1) a **10% raise**.\n\nAfter your UPDATE, verify with:\n\`\`\`sql\nSELECT first_name, last_name, salary FROM employees WHERE dept_id = 1 ORDER BY id;\n\`\`\``,
  schemaDDL,
  seedDML,
  expectedOutput: {
   columns: ['first_name', 'last_name', 'salary'],
   values: [
    ['Alice', 'Johnson', 104500.0],
    ['Bob', 'Smith', 96800.0],
    ['Frank', 'Miller', 101200.0],
   ],
  },
  comparisonMode: 'order-sensitive',
  difficulty: 'easy',
  topicTags: ['dml'],
  hints: [
   'Use UPDATE employees SET salary = salary * 1.10 WHERE dept_id = 1;',
   'Follow the UPDATE with a SELECT to verify the new salaries.',
   'The last SELECT result is what gets compared to the expected output.',
  ],
 },
 {
  id: 'dml-medium-1',
  title: 'Remove Unassigned Employees',
  statement: `Delete all employees who are **not assigned to any department** (dept_id IS NULL).\n\nAfter your DELETE, verify with:\n\`\`\`sql\nSELECT first_name, last_name, dept_id FROM employees ORDER BY id;\n\`\`\``,
  schemaDDL,
  seedDML,
  expectedOutput: {
   columns: ['first_name', 'last_name', 'dept_id'],
   values: [
    ['Alice', 'Johnson', 1],
    ['Bob', 'Smith', 1],
    ['Carol', 'Williams', 2],
    ['David', 'Brown', 2],
    ['Eva', 'Davis', 3],
    ['Frank', 'Miller', 1],
    ['Henry', 'Taylor', 3],
    ['Ivy', 'Anderson', 4],
   ],
  },
  comparisonMode: 'order-sensitive',
  difficulty: 'medium',
  topicTags: ['dml'],
  hints: [
   'Use DELETE FROM employees WHERE dept_id IS NULL;',
   'IS NULL checks for NULL values — do not use = NULL.',
   'Follow the DELETE with a SELECT to verify remaining employees.',
  ],
 },
];
